// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentCaregiverModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentCaregiverModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentCaregiverModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentCaregiverModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentCaregiverModel.attributeTypeMap = [
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "fullName",
        "baseName": "fullName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "relationshipToPatient",
        "baseName": "relationshipToPatient",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentCaregiverModel.js.map